import { Section, TitleAndDescription } from '@ferreri/prever-component-lib';
import { ContractEmptyState } from 'modules/contract/ContractEmptyState';

export const PetCremationBenefitContractEmptyState = () => {
  return (
    <Section>
      <TitleAndDescription
        title="Somente para associados"
        description="Para ter direito ao Proteção Pet você precisa ser um associado. Adquira um plano ou vincule o seu, caso já seja um associado com o benefício pet incluído no plano."
      />
      <ContractEmptyState />
    </Section>
  );
};
